<template>
  <section class="products">
    <TabNav
      :items="navItems"
      class="products__navigation"
    >
      <template v-slot:item="{ item }">
        <Intro
          :config="item.config"
          @buttonClick="introButtonHandler"
        />
      </template>
    </TabNav>

    <ProductCollection
      v-if="config.available"
      ref="collection"
      :title="config.collection.title"
      :products="products"
      :theme="config.theme"
      class="products__collection"
    />

    <ButtonVideoMobile
      v-if="buttonVideoConfig.available"
      v-bind="buttonVideoConfig.props"
      :theme="config.theme"
      class="products__button-video"
    />

    <MobileFooterNav
      :config="config"
      class="products__footer-navigation"
    />
  </section>
</template>

<script>
import Intro from '@/components/Intro.vue';
import ProductCollection from '@/components/ProductCollection.vue';
import TabNav from '@/components/navigation/TabNav.vue';
import MobileFooterNav from '@/components/navigation/MobileFooterNav.vue';
import ButtonVideoMobile from '@/components/buttons/ButtonVideoMobile.vue';

export default {
  name: 'Products',

  components: {
    Intro,
    ProductCollection,
    TabNav,
    MobileFooterNav,
    ButtonVideoMobile,
  },

  computed: {
    routeName() {
      return this.$route.name;
    },

    config() {
      return this.$store.getters.getDataById(this.routeName);
    },

    products() {
      return this.config.products;
    },

    navItems() {
      const productRoutes = this.$store.getters.getCollectionRoutes();
      return productRoutes.map(r => ({
        label: r.label,
        path: r.path,
        theme: r.theme,
        config: this.$store.getters.getRouteConfig(r),
      }));
    },

    buttonVideoConfig() {
      return this.$store.getters.getButtonVideoConfigByConfig(this.config);
    },
  },

  methods: {
    introButtonHandler() {
      if (!this.$refs.collection) return;

      this.$refs.collection.$el.scrollIntoView({ behavior: 'smooth' });
    },
  },
};
</script>

<style lang="stylus">
.products__navigation {
  height: auto;

  +desktop() {
    height: 100vh;
    min-height: 600px;
    max-height: 900px;
  }
}

.products__footer-navigation {
  position: sticky;
  bottom: 0;
  z-index: 1;

  +desktop() { display: none; }
}

.products__button-video {
  +desktop() { display: none; }
}
</style>
